module.exports = function () {
  /*
    * Animation Hover language swicther
  */
  const langSwitcher = document.querySelector('.lang-switcher');
  if (langSwitcher) {
    langSwitcher.addEventListener('mouseenter', () => {
      langSwitcher.classList.add('js-is-hover');
    });
    langSwitcher.addEventListener('mouseleave', () => {
      langSwitcher.classList.remove('js-is-hover');
    });
  }

  /*
    * Affichage Search box dans le header
  */
  const searchButton = document.querySelector('.header-right__icon--search');
  if (searchButton) {
    searchButton.addEventListener('click', (e) => {
      e.preventDefault();

      const searchBox = document.querySelector('.search-box');
      searchBox.classList.add('js-is-visible');

      // focus input when click on search icon in menu
      const searchValue = $('.search-form input[type="search"]');
      searchValue.focus();
    });
  }

  /*
    * Fermeture Search box dans le header
  */
  const searchClose = document.querySelector('.search-box__close');
  if (searchClose) {
    searchClose.addEventListener('click', () => {
      const searchBox = document.querySelector('.search-box');
      const searchWrapper = document.querySelector('.search-box__wrapper');
      searchBox.classList.remove('js-is-visible');
      searchWrapper.classList.remove('js-is-open');
    });
  }

};